<template>
  <div id="tabBox">
    <div class="tabs">
      <input type="radio" value="1" id="tab1" v-model="selectedTab">
      <label for="tab1">Course history</label>
      <input type="radio" value="2" id="tab2" v-model="selectedTab">
      <label for="tab2">SPIR history</label>
      <input type="radio" value="3" id="tab3" v-model="selectedTab">
      <label for="tab3">Wetec history</label>
      <input type="radio" value="4" id="tab4" v-model="selectedTab">
      <label for="tab4">Grade history</label>
    </div>
    <ul class="contents">
      <li v-if="selectedTab == 1">
        <CourseHistory :histories="student.courseHistories"/>
      </li>
      <li v-else-if="selectedTab == 2">
        <SPIRHistory :histories="student.spirHistories"/>
      </li>
      <li v-else-if="selectedTab == 3">
        <WetecHistory :histories="student.wetecHistories"/>
      </li>
      <li v-else-if="selectedTab == 4">
        <GradeHistory :histories="student.gradeHistories"/>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
import { Vue, Prop, Component } from 'vue-property-decorator'
import CourseHistory from '@/components/parts/students/StudentCourseHistory.vue';
import WetecHistory from '@/components/parts/students/StudentWetecHistory.vue';
import SPIRHistory from '@/components/parts/students/StudentSPIRHistory.vue';
import GradeHistory from '@/components/parts/students/StudentGradeHistory.vue';
import { Student } from '@/store/students/types';

@Component({
  components: {
    CourseHistory,
    WetecHistory,
    SPIRHistory,
    GradeHistory,
  },
})
export default class StudentTab extends Vue {
  @Prop() student!: Student

  private selectedTab: string = '1'
}
</script>

<style scoped>
label {
  margin-bottom: 0
}

ul {
  padding: 0;
  margin: 0;
}

li {
  list-style: none;
}

h1 {
  font-size : 16px;
  margin: 0;
}

p {
  margin: 0;
  font-size: 15px;
}

.tabs {
  overflow: hidden;
  display: flex;
  padding-left:40px;
}

.tabs input {
  display: none;
}

.tabs label {
  display: inline-block;
  line-height: 40px;
  width: 150px;
  text-align: center;
  cursor: pointer;
  background: #1cc8a0;
  color: #fff;
  transition: 0.3s ease-in-out;
  border-radius: 10px 10px 0 0;
}

.tabs input:checked + label,
.tabs label:hover {
  background: #bdbcbc;
  color: #000;
}

.contents {
  padding: 40px;
  height:500px;
  margin-bottom:20px;
  background: #fff;
  border-radius: 20px ;
}

</style>
